import React from 'react';
import AdditionalOptions from './AdditionalOptions.component';
import CarrierServicesFilter from './CarrierServicesFilter.component';
import PackageFilter from './PackageFilter.component';
import SliderFilters from './SliderFilters.component';

const Filter = ({ rateAdvisorData, serviceResults, onFiltersChange }) => (
	<div className="common-rate-advisor-filter">
		<p className="title">Filters</p>

		<CarrierServicesFilter
			serviceResults={serviceResults}
			rateAdvisorData={rateAdvisorData}
			onFiltersChange={onFiltersChange}
		/>

		<PackageFilter
			rateAdvisorData={rateAdvisorData}
			onFiltersChange={onFiltersChange}
		/>

		<SliderFilters
			serviceResults={serviceResults}
			rateAdvisorData={rateAdvisorData}
			onFiltersChange={onFiltersChange}
		/>

		<AdditionalOptions
			rateAdvisorData={rateAdvisorData}
			onFiltersChange={onFiltersChange}
		/>
	</div>
);

export default Filter;
